/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { PlayerPlayIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import { useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function VideoPlayer({
  onTrackInteraction,
  playAnalyticsId,
  thumbnailUrl,
  videoUrl
}) {
  const video = useRef(null);
  const [showOverlay, setShowOverlay] = useState(true);
  return /*#__PURE__*/_jsxs("figure", {
    style: {
      position: 'relative',
      zIndex: '1',
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx("video", {
      ref: video,
      controls: !showOverlay,
      preload: "metadata",
      width: "100%",
      poster: thumbnailUrl || `${videoUrl}\\medium.jpg`,
      onEnded: () => {
        if (onTrackInteraction) onTrackInteraction('complete video');
      },
      children: /*#__PURE__*/_jsx("source", {
        src: videoUrl,
        type: "video/mp4"
      })
    }), showOverlay && /*#__PURE__*/_jsx(Clickable, {
      "data-hs-analytics-id": playAnalyticsId,
      onClick: event => {
        event.preventDefault();
        if (onTrackInteraction) {
          onTrackInteraction('start video');
        }
        setShowOverlay(false);
        if (video && video.current) {
          video.current.play();
        }
      },
      children: /*#__PURE__*/_jsx(Overlay, {
        padding: "0",
        contextual: true,
        use: "dark",
        width: "100%",
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          blockSize: "100%",
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            justifyContent: "center",
            blockSize: "100%",
            children: /*#__PURE__*/_jsx(IconCircle, {
              icon: PlayerPlayIcon,
              color: "icon-primary-on-fill-default",
              backgroundColor: "fill-primary-default",
              size: "600",
              borderWidth: "0"
            })
          })
        })
      })
    })]
  });
}